var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "preview_wrap"
    },
    [
      _c("div", { staticClass: "preview_midle" }, [
        _c("div", { staticClass: "header" }, [
          _c("p", [_vm._v(_vm._s(_vm.name) + "（" + _vm._s(_vm.total) + "）")])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tabs" },
          [
            _c(
              "el-tabs",
              {
                on: { "tab-click": _vm.handleClick },
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              _vm._l(_vm.questionTabNames, function(item, index) {
                return _c("el-tab-pane", {
                  key: index,
                  attrs: {
                    label: item.sectionAlias || item.sectionName,
                    name: "page" + index
                  }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "content",
            staticClass: "section",
            style: { height: _vm.styleHeight },
            on: { scroll: _vm.handleScroll }
          },
          [
            _c("div", { staticClass: "test" }, [
              _c(
                "ul",
                _vm._l(_vm.questionContent, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "test-item",
                      attrs: { id: ["page" + index] }
                    },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(
                          _vm._s(_vm.chnNumCharStr(index)) +
                            "  、" +
                            _vm._s(item.sectionAlias || item.sectionName)
                        ),
                        _c("span", [
                          _vm._v("（" + _vm._s(item.sectionPrompt) + "）")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(item.questions, function(v, i) {
                          return _c(
                            "li",
                            { key: i, staticClass: "test_small" },
                            [
                              v.internalTypeId !== 6
                                ? _c("div", [
                                    v.internalTypeId === 9
                                      ? _c(
                                          "span",
                                          { staticClass: "text_index1" },
                                          [_vm._v(_vm._s(v.questionNum) + ".")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "text_box" }, [
                                      v.internalTypeId !== 9
                                        ? _c(
                                            "span",
                                            { staticClass: "text_index" },
                                            [
                                              _vm._v(
                                                _vm._s(v.questionNum) + "."
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      v.internalTypeId === 9
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "test_small_title1"
                                            },
                                            [
                                              _c("p", {
                                                staticClass:
                                                  "text editorShowArea ql-editor",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    v.questionContent
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      v.internalTypeId !== 9
                                        ? _c("div", {
                                            staticClass:
                                              "test_small_title editorShowArea ql-editor",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                v.questionContent
                                              )
                                            }
                                          })
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    v.internalTypeId === 1
                                      ? _c(
                                          "ul",
                                          {
                                            staticClass: "answer editorShowArea"
                                          },
                                          [
                                            _c(
                                              "el-radio-group",
                                              {
                                                model: {
                                                  value: v.questionAnswer,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      v,
                                                      "questionAnswer",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "v.questionAnswer"
                                                }
                                              },
                                              _vm._l(v.items, function(k, j) {
                                                return _c(
                                                  "li",
                                                  { key: j },
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      {
                                                        attrs: {
                                                          label: k.itemKey,
                                                          disabled:
                                                            v.questionAnswer ==
                                                            k.itemKey
                                                              ? false
                                                              : true
                                                        }
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(k.itemKey) +
                                                              "："
                                                          )
                                                        ]),
                                                        _c("div", {
                                                          staticClass:
                                                            "radio_item editorShowArea ql-editor",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              k.itemValue
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              }),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    v.internalTypeId === 2
                                      ? _c(
                                          "ul",
                                          { staticClass: "answer" },
                                          [
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                model: {
                                                  value: v.questionAnswer.split(
                                                    ","
                                                  ),
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      v.questionAnswer,
                                                      "split(',')",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "v.questionAnswer.split(',')"
                                                }
                                              },
                                              _vm._l(v.items, function(k, j) {
                                                return _c(
                                                  "li",
                                                  { key: j },
                                                  [
                                                    _c(
                                                      "el-checkbox",
                                                      {
                                                        attrs: {
                                                          disabled: v.questionAnswer.includes(
                                                            k.itemKey
                                                          )
                                                            ? false
                                                            : true,
                                                          label: k.itemKey
                                                        }
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(k.itemKey) +
                                                              "："
                                                          )
                                                        ]),
                                                        _c("p", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              k.itemValue
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              }),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    v.internalTypeId === 3
                                      ? _c("ul", { staticClass: "answer" }, [
                                          _c(
                                            "li",
                                            [
                                              _c(
                                                "el-radio",
                                                {
                                                  attrs: {
                                                    label: "正确",
                                                    disabled:
                                                      v.questionAnswer == "错误"
                                                        ? true
                                                        : false
                                                  },
                                                  model: {
                                                    value: v.questionAnswer,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        v,
                                                        "questionAnswer",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "v.questionAnswer"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.answerExchange(
                                                        v.englishOption,
                                                        "正确"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "li",
                                            [
                                              _c(
                                                "el-radio",
                                                {
                                                  attrs: {
                                                    label: "错误",
                                                    disabled:
                                                      v.questionAnswer == "正确"
                                                        ? true
                                                        : false
                                                  },
                                                  model: {
                                                    value: v.questionAnswer,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        v,
                                                        "questionAnswer",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "v.questionAnswer"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.answerExchange(
                                                        v.englishOption,
                                                        "错误"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    v.internalTypeId === 1 ||
                                    v.internalTypeId === 2 ||
                                    v.internalTypeId === 3
                                      ? _c("p", [
                                          _vm._v("正确答案："),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.answerExchange(
                                                  v.englishOption,
                                                  v.questionAnswer
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    v.internalTypeId === 4
                                      ? _c("div", [
                                          _vm._v(
                                            "正确答案\n                    "
                                          ),
                                          _c(
                                            "div",
                                            { staticStyle: { margin: "10px" } },
                                            _vm._l(
                                              JSON.parse(v.questionAnswer),
                                              function(item, key, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: key,
                                                    attrs: { index: index }
                                                  },
                                                  _vm._l(item, function(a, b) {
                                                    return _c(
                                                      "div",
                                                      { key: b },
                                                      [
                                                        item.length > 1
                                                          ? _c("div", [
                                                              b < 1
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle: {
                                                                        margin:
                                                                          "10px",
                                                                        color:
                                                                          "#5397F7"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            index -
                                                                              0 +
                                                                              1 +
                                                                              "、答案：" +
                                                                              a
                                                                          ) +
                                                                          "\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle: {
                                                                        margin:
                                                                          "10px 0 0 35px",
                                                                        color:
                                                                          "#5397F7"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              " +
                                                                          _vm._s(
                                                                            "备选答案" +
                                                                              b +
                                                                              ":" +
                                                                              a
                                                                          ) +
                                                                          "\n                            "
                                                                      )
                                                                    ]
                                                                  )
                                                            ])
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  margin:
                                                                    "10px",
                                                                  color:
                                                                    "#5397F7"
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      index -
                                                                        0 +
                                                                        1 +
                                                                        "、答案：" +
                                                                        a
                                                                    ) +
                                                                    "\n                          "
                                                                )
                                                              ]
                                                            )
                                                      ]
                                                    )
                                                  }),
                                                  0
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    v.flag && v.internalTypeId !== 9
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "analysis",
                                            on: {
                                              click: function($event) {
                                                return _vm.openAnalysis(v)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v("打开解析"),
                                            _c("img", {
                                              attrs: { src: _vm.imgSrcDown }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !v.flag && v.internalTypeId !== 9
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "analysis",
                                            on: {
                                              click: function($event) {
                                                return _vm.openAnalysis(v)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v("收起解析"),
                                            _c("img", {
                                              attrs: { src: _vm.imgSrcUp }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !v.flag && v.internalTypeId !== 9
                                      ? _c("span", {
                                          staticClass:
                                            "analysis_cont editorShowArea ql-editor",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              v.questionAnalysis
                                                ? v.questionAnalysis
                                                : "暂无解析"
                                            )
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    v.flag && v.internalTypeId === 9
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "answerShow",
                                            on: {
                                              click: function($event) {
                                                return _vm.openAnalysis(v)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v("打开答案"),
                                            _c("img", {
                                              attrs: { src: _vm.imgSrcDown }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !v.flag && v.internalTypeId === 9
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "answerHide",
                                            on: {
                                              click: function($event) {
                                                return _vm.openAnalysis(v)
                                              }
                                            }
                                          },
                                          [
                                            _vm._v("收起答案"),
                                            _c("img", {
                                              attrs: { src: _vm.imgSrcUp }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !v.flag && v.internalTypeId == 9
                                      ? _c(
                                          "div",
                                          { staticClass: "commentCont" },
                                          [
                                            _c("div", {
                                              staticClass: "comment1"
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "comment2" },
                                              [
                                                _c("my-component", {
                                                  attrs: {
                                                    isShow: "",
                                                    optObject: _vm.optObject,
                                                    refresh: _vm.refresh,
                                                    myId: v.questionId,
                                                    type: _vm.type,
                                                    preview: true,
                                                    companyCode: _vm.companyCode
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("div", {
                                              staticClass: "comment3"
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              v.internalTypeId === 6 &&
                              item.questions.length > 1
                                ? _c("div", { staticClass: "line" })
                                : _vm._e(),
                              _vm._v(" "),
                              v.internalTypeId === 6
                                ? _c(
                                    "div",
                                    { staticClass: "combination" },
                                    [
                                      v.internalTypeId === 9
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "test_small_title1"
                                            },
                                            [
                                              _c("p", {
                                                staticClass:
                                                  "text editorShowArea ql-editor",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    v.questionContent
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      v.questionNum ==
                                      v.questionNum +
                                        v.childQuestions.length -
                                        1
                                        ? _c(
                                            "p",
                                            { staticClass: "question_index" },
                                            [
                                              _vm._v(
                                                "阅读以下内容，回答第" +
                                                  _vm._s(v.questionNum) +
                                                  "题"
                                              )
                                            ]
                                          )
                                        : _c(
                                            "p",
                                            { staticClass: "question_index" },
                                            [
                                              _vm._v(
                                                "阅读以下内容，回答第" +
                                                  _vm._s(v.questionNum) +
                                                  "-" +
                                                  _vm._s(
                                                    v.questionNum +
                                                      v.childQuestions.length -
                                                      1
                                                  ) +
                                                  "题"
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      v.internalTypeId !== 9
                                        ? _c("div", {
                                            staticClass: "test_small_title",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                v.questionContent
                                              )
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._l(v.childQuestions, function(
                                        single,
                                        m
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: m,
                                            staticClass: "groupQuestion"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "question_content"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(single.questionNum) +
                                                      "."
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c("p", {
                                                  staticClass:
                                                    "text editorShowArea ql-editor",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      single.questionContent
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            single.internalTypeId === 1
                                              ? _c(
                                                  "ul",
                                                  { staticClass: "answer" },
                                                  [
                                                    _c(
                                                      "el-radio-group",
                                                      {
                                                        model: {
                                                          value:
                                                            single.questionAnswer,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              single,
                                                              "questionAnswer",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "single.questionAnswer"
                                                        }
                                                      },
                                                      _vm._l(
                                                        single.items,
                                                        function(k, j) {
                                                          return _c(
                                                            "li",
                                                            { key: j },
                                                            [
                                                              _c(
                                                                "el-radio",
                                                                {
                                                                  attrs: {
                                                                    label:
                                                                      k.itemKey,
                                                                    disabled:
                                                                      single.questionAnswer ==
                                                                      k.itemKey
                                                                        ? false
                                                                        : true
                                                                  }
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        k.itemKey
                                                                      ) + "："
                                                                    )
                                                                  ]),
                                                                  _c("div", {
                                                                    staticClass:
                                                                      "radio_item editorShowArea ql-editor",
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        k.itemValue
                                                                      )
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            single.internalTypeId === 2
                                              ? _c(
                                                  "ul",
                                                  { staticClass: "answer" },
                                                  [
                                                    _c(
                                                      "el-checkbox-group",
                                                      {
                                                        model: {
                                                          value: single.questionAnswer.split(
                                                            ","
                                                          ),
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              single.questionAnswer,
                                                              "split(',')",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "single.questionAnswer.split(',')"
                                                        }
                                                      },
                                                      _vm._l(
                                                        single.items,
                                                        function(k, j) {
                                                          return _c(
                                                            "li",
                                                            { key: j },
                                                            [
                                                              _c(
                                                                "el-checkbox",
                                                                {
                                                                  attrs: {
                                                                    disabled: single.questionAnswer.includes(
                                                                      k.itemKey
                                                                    )
                                                                      ? false
                                                                      : true,
                                                                    label:
                                                                      k.itemKey
                                                                  }
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        k.itemKey
                                                                      ) + "："
                                                                    )
                                                                  ]),
                                                                  _c("p", {
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        k.itemValue
                                                                      )
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            single.internalTypeId === 3
                                              ? _c(
                                                  "ul",
                                                  { staticClass: "answer" },
                                                  [
                                                    _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "el-radio",
                                                          {
                                                            attrs: {
                                                              label: "正确",
                                                              disabled:
                                                                single.questionAnswer ==
                                                                "错误"
                                                                  ? true
                                                                  : false
                                                            },
                                                            model: {
                                                              value:
                                                                single.questionAnswer,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  single,
                                                                  "questionAnswer",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "single.questionAnswer"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.answerExchange(
                                                                  single.englishOption,
                                                                  "正确"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "li",
                                                      [
                                                        _c(
                                                          "el-radio",
                                                          {
                                                            attrs: {
                                                              label: "错误",
                                                              disabled:
                                                                single.questionAnswer ==
                                                                "正确"
                                                                  ? true
                                                                  : false
                                                            },
                                                            model: {
                                                              value:
                                                                single.questionAnswer,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  single,
                                                                  "questionAnswer",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "single.questionAnswer"
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.answerExchange(
                                                                  single.englishOption,
                                                                  "错误"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            single.internalTypeId === 1 ||
                                            single.internalTypeId === 2 ||
                                            single.internalTypeId === 3
                                              ? _c("p", [
                                                  _vm._v("正确答案："),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.answerExchange(
                                                          single.englishOption,
                                                          single.questionAnswer
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            single.internalTypeId === 4
                                              ? _c("div", [
                                                  _vm._v("正确答案："),
                                                  _c("p", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        single.questionAnswer
                                                      )
                                                    }
                                                  })
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            single.flag &&
                                            single.internalTypeId !== 9
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "analysis",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openAnalysis(
                                                          single
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v("打开解析"),
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.imgSrcDown
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !single.flag &&
                                            single.internalTypeId !== 9
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "analysis",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openAnalysis(
                                                          single
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v("收起解析"),
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.imgSrcUp
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !single.flag &&
                                            single.internalTypeId !== 9
                                              ? _c("span", {
                                                  staticClass:
                                                    "analysis_cont editorShowArea ql-editor",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      single.questionAnalysis
                                                        ? single.questionAnalysis
                                                        : "暂无解析"
                                                    )
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            single.flag &&
                                            single.internalTypeId === 9
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "answerShow",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openAnalysis(
                                                          single
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v("打开答案"),
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.imgSrcDown
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !single.flag &&
                                            single.internalTypeId === 9
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "answerHide",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.openAnalysis(
                                                          single
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v("收起答案"),
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.imgSrcUp
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            !single.flag &&
                                            single.internalTypeId == 9
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "commentCont"
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass: "comment1"
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "comment2"
                                                      },
                                                      [
                                                        _c("my-component", {
                                                          attrs: {
                                                            isShow: "",
                                                            optObject:
                                                              _vm.optObject,
                                                            refresh:
                                                              _vm.refresh,
                                                            myId:
                                                              single.questionId,
                                                            type: _vm.type,
                                                            preview: true,
                                                            companyCode:
                                                              _vm.companyCode
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticClass: "comment3"
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              v.internalTypeId === 6 &&
                              item.questions.length > 1
                                ? _c("div", { staticClass: "line" })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticStyle: { clear: "both" } })
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77e3e6f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77e3e6f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testing/preview.vue
// module id = null
// module chunks = 